export enum EntityType {
  CoManagedEntity = 'CoManagedEntity',
  SelfManagedEntity = 'SelfManagedEntity',
}
